import React from 'react'
import Mainlayout from '../layout/Mainlayout'
import { BsShop } from "react-icons/bs";
import { IoFootball } from "react-icons/io5";
import { SiMinds } from "react-icons/si";
import { TbTallymarks } from "react-icons/tb";
import {  GiTrophyCup } from "react-icons/gi";


export default function Info() {
    return (
        <Mainlayout>
            <div className='min-h-screen bg-dwam text-shasham flex-row-reverse '>
                <h1 className='text-center text-3xl text-shasham p-2'>ناساندنی پەڕەکان</h1>
                <div className=' w-full flex flex-row-reverse justify-center p-2'>
                    <BsShop className='w-16 h-16 mx-2 md:mx-4 p-1' />
                    <p className='md:text-right text-center border-t-2 border-shasham p-1 md:w-1/2 w-full'>بەشی کاڵاوەرزشیەکان پێکهاتوە لە سێ بەشی سەرەکی کە تێیدا بەکارهێنەران دەتوانن کاڵاوەرزشیەکانیان لەوێ بەدەست بهێنن پاش زیاد کردنی
                        کاڵاکە بۆ سەبەتەکەت دەتوانی لە سەبەتەکەت بیانبینیتەوەو پاشان بیان کڕیت. ئەگەر نرخی گشتی بگاتە $100 داشکانی لەسەدا ٢٠ بەدەست دەهێنیت</p>
                </div>
                <div className=' w-full flex flex-row-reverse justify-center p-2'>
                    <IoFootball className='w-16 h-16 mx-2 md:mx-4 p-1' />
                    <p className='md:text-right text-center border-t-2 border-shasham p-1 md:w-1/2 w-full'>
                        بەشی یاریەکان لەم پەڕە دەتوانی خشتەی یاریەکان و وڵاتە بەشداربوەکان ببینیت لەگەڵ ئەنجامی یاریەکان
                    </p>
                </div>
                <div className=' w-full flex flex-row-reverse justify-center p-2'>
                    <SiMinds className='w-16 h-16 mx-2 md:mx-4 p-1' />
                    <p className='md:text-right text-center border-t-2 border-shasham p-1 md:w-1/2 w-full'>
                        بەشی پێشبینیکردن لەم بەشەدەتوانی پێشبینی بکەیت بۆ یاریەکان کانی ڕۆژ وە بینینی خەڵاتی ڕۆژ
                    </p>
                </div>
                <div className=' w-full flex flex-row-reverse justify-center p-2'>
                    <TbTallymarks className='w-16 h-16 mx-2 md:mx-4 p-1' />
                    <p className='md:text-right text-center border-t-2 border-shasham p-1 md:w-1/2 w-full'>
                        بەشی خاڵەکان لەم پەڕە دەتوانی پێشبینی ئەوکەسانە ببینیت کە پێشنیان ڕاستە وەدەتوانی براوەی ڕۆژ ببینیت وەکۆی خاڵەکانی خۆت ببینیت
                    </p>
                </div>
                <h1 className='text-center text-3xl text-shasham p-2'>میکانیزمی بردنەوە</h1>
                <div className=' w-full flex flex-row-reverse justify-center p-2'>
                    <GiTrophyCup className='w-16 h-16 mx-2 md:mx-4 p-1' />
                    <p className='md:text-right text-center p-1 md:w-1/2 w-full'>
                        هەر بەشداربویەک دەتوانێت پێشبینی بکات بۆ هەر یاریەکی ڕۆژەکە و بۆ هەر پێشبینیەکی ڕاست دەبیتە خاوەنی خاڵ کە خاڵەکان 
                        بە پێی قۆناغی یاریەکان زیاد دەکات واتە کۆمەڵەکان ١ خاڵ بۆ هەرقۆناغێکی دواتر خاڵەکان دووهێندە دەبن، بەشداربوان بۆ هەر پێشبینیەکی ڕاستی ڕۆژەکە یەک جار ناویان دەچێتە لیستی پێشبینیە ڕاستەکان تاپێشبینیان زیاتر ڕاست بێت هەلی بردنەوەیان زیاترە بۆ خەڵاتی ڕۆژەکە . لە کۆتای دەورەکەشدا ٣ زۆرترین خاڵەکان دەبنە براوەی خەڵات 
                    </p>
                </div>
            </div>
        </Mainlayout>
    )
}
